export function forminatorButtons() {
    let $button = $('button.forminator-button');
    $button.each(function () {
        let $this = $(this);
        let buttonValue = $this.text();
        $this.text("");
        $this.append("<span class='button-inner'><span>" + buttonValue + "</span><span>" + buttonValue + "</span></span>");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/forminatorButtons.js